import { t } from 'translate/i18n';
import * as yup from 'yup';
import 'yup-phone';

const translationString = 'components.battle.schemas.createABetModalSchema';

const battleSchema = yup.object().shape({
  amount: yup
    .string()
    .required(t(`${translationString}.amount.required`))
    .notOneOf(['0'], t(`${translationString}.amount.min`)),

  password: yup.string().required(t(`${translationString}.password.required`))
});

const tournamentSchema = yup.object().shape({
  amount: yup
    .string()
    .required(t(`${translationString}.amount.required`))
    .notOneOf(['0'], t(`${translationString}.amount.min`))
});

export { battleSchema, tournamentSchema };
